import { axios } from "../axios.instance";

export type ViewMatchRequest = {
  userIds: string[];
};

export type ViewMatchResponse = null;

export const viewMatch = async (body: ViewMatchRequest): Promise<ViewMatchResponse> => {
  const { data } = await axios.post("views/users/view", body);

  return data;
};
